import React, { useState, useEffect } from "react";
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import SettingsIcon from '@mui/icons-material/Settings';
import WalletIcon from '@mui/icons-material/Wallet';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import Account from "./AccountReconciliaitonPage";
import PaymentUi from '../Payments/AllPaymentsNewTab'
import PaymentInsigts from '../Payments/PaymentInsights/PaymentInsightsMain'
import OverDueEmi from "../../Admin/ApplicationLeads/overdueLeads.container";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { ROLE } from "../../../../utils/Constant";
import { Insights, Payment, UnarchiveRounded, VoiceOverOffRounded } from "@mui/icons-material";
import PaymentsMainTab from "./PaymentsMainTab";
import SettleMents from "../Payments/Settlements/Main";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Audit from '../Payments/PaymentAudit/Main'
import moment from "moment";
import Pagination from '@mui/material/Pagination';
// import TargetList from "./Targetssalary/mainTargets";
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import { CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT } from "../../../../layouts/MainTenantconfig";

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

const MainEmp = ({ admin, allStatus, newDataBackground, pageViewHandler }) => {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const [viewType, setviewType] = useState('allpayments')
    const [editData, seteditData] = useState('')
    const [headerHide, setHeaderHide] = useState(false)

    const [payload, setPayload] = useState({
        startDate: fromDate,
        endDate: toDate,
    })

    useEffect(() => {
        setPayload({
            startDate: fromDate,
            endDate: toDate,
        })

    }, [fromDate, toDate]);

    const handlePayload = (data) => {
        dispatch({ type: FILTER_ACTION, payload: { fromDate: data?.startDate, toDate: data?.endDate } });
        console.log("da", data)
        setPayload(data)
    }


    const editHandler = (data) => {
        console.log(data)
        if (data.id) {
            seteditData(data)
            setviewType('add')
        }



    }

    const handleTabs = (type) => {
        setviewType(type)
    }

    const HeadingHide = (value) => {
        setHeaderHide(value)
    }

    return (
        <>
            {
                !headerHide ?
                    <div className="container-fluid details-new fixed-top" style={{ zIndex: '3' }} >
                        <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                            <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px' }}>
                                <img onClick={(e) => pageViewHandler(e, 'landingPage')} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => pageViewHandler(e, 'landingPage')} >Back</button>
                            </div>

                            <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>


                                <div className="btn-group-new">
                                    <button className={(viewType === 'allpayments') ? "active" : ""} onClick={() => handleTabs('allpayments')}><Payment style={{ fontSize: '27px' }} /><br />All Payments</button>
                                    <button className={(viewType === 'payments') ? "active" : ""} onClick={() => handleTabs('payments')}><Payment style={{ fontSize: '27px' }} /><br />Payments</button>
                                    {
                                        admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                            admin.rolelist.indexOf(ROLE.Payment_Insight) >= 0 ?
                                                <button className={(viewType === 'insights') ? "active" : ""} onClick={() => handleTabs('insights')}><Insights style={{ fontSize: '27px' }} /><br />Payment Insights</button>
                                                : '' : ''}
                                    {
                                        !CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                                            <button className={(viewType === 'reconcilation') ? "active" : ""} onClick={() => handleTabs('reconcilation')}><WalletIcon style={{ fontSize: '27px' }} /><br />Account Reconciliation</button>
                                            : ""}
                                    <button className={(viewType === 'overdue') ? "active" : ""} onClick={() => handleTabs('overdue')}><ReceiptIcon style={{ fontSize: '27px' }} /><br />Overdue Emi's</button>
                                    <button className={(viewType === 'settlement') ? "active" : ""} onClick={() => handleTabs('settlement')}><DoneAllIcon style={{ fontSize: '27px' }} /><br />Settlements</button>
                                    <button className={(viewType === 'audit') ? "active" : ""} onClick={() => handleTabs('audit')}><AssignmentIcon style={{ fontSize: '27px' }} /><br />Audit</button>

                                </div>

                            </div>
                        </div>
                    </div>
                    : ""}
            <div style={{ marginTop: viewType === 'reconcilation' ? '1.5%' : viewType === 'payments' ? "16px" : viewType === 'allpayments' || viewType === 'settlement' ? "0px" : '60px' }}>
                {viewType === 'reconcilation' ?
                    <Account admin={admin}
                        allStatus={allStatus}
                        newDataBackground={newDataBackground} showButton={false} editHandler={editHandler} />
                    : ""}
                {viewType === 'allpayments' ?
                    <PaymentUi showButton={false} admin={admin} editData={editData} payload={payload} handlePayload={handlePayload} />
                    : ""}

                {viewType === 'payments' ?
                    <PaymentsMainTab showButton={false} admin={admin} editData={editData} payload={payload} handlePayload={handlePayload} />
                    : ""}
                {viewType === 'insights' ?
                    <PaymentInsigts showButton={false} admin={admin} editData={editData} />
                    : ""}
                {viewType === 'overdue' ?
                    <OverDueEmi showButton={false} admin={admin} editData={editData} HeadingHide={HeadingHide} payload={payload} handlePayload={handlePayload} />
                    : ""}
                {viewType === 'settlement' ?
                    <SettleMents showButton={false} admin={admin} payload={payload} handlePayload={handlePayload} InitalDate={InitalDate} />
                    : ""}
                {viewType === 'audit' ?
                    <Audit showButton={false} admin={admin} HeadingHide={HeadingHide} payload={payload} handlePayload={handlePayload} />
                    : ""}

            </div>

        </>
    )
}
export default MainEmp